import React, { useMemo } from 'react';
import FeedCardItem from "../FeedCard/FeedCardItem";
import FeedsFallback from "./FeedsFallback";
import { wrapDataShimmer } from "../Shimmer/DataShimmer";
import { mapChildData, filterFeedByCategory } from "../../helpers/helpers";
import CategoryFilter from './CategoryFilter';
const shimmerProps = { height: "300px" };
const requires = ["feeds"];
const shimmerItemCount = 6;

export function Feeds(props) {
  const { requiredData, selectedCategory } = props;
  const { feeds } = requiredData;
  
  const filteredFeed = useMemo(() => {
    if (selectedCategory !== "all") {
      return filterFeedByCategory(selectedCategory, feeds);
    }
    return feeds;
  }, [selectedCategory, feeds]);

  return (
    <>
      <div className="update-feed-header">
        <h2 className="epsilon">My Updates</h2>
        <CategoryFilter selectedCategory={selectedCategory}/>
      </div>
      {filteredFeed.map((itemData, index) => 
        (
          <FeedCardItem 
            index={index}
            key={itemData.id}
            itemData={itemData}
          />
        )
      )}
    </>
  );
}

export default wrapDataShimmer(Feeds, {
  shimmerProps, 
  requires, 
  shimmerItemCount,
  FallbackComponent: FeedsFallback
});